export default __webpack_public_path__ + "static/form-backgrounds-93fb02c23266dbb997e42ce613bdbded.jpg";